/** saves cards list
@payload { Array }https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardsgetCards
*/
export const SAVE_CARDS_LIST = (state, payload) => {
    state.cardsList = payload.map(card => {
        return {
            ...card,
            friendlyName: card.additionalInfoCardView.friendlyName ? card.additionalInfoCardView.friendlyName : ''
        }
    })
}

/** saves card movements
@payload { Array }https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cards%7Bid%7DmovementsV2
*/
export const SAVE_CARD_MOVEMENTS = (state, { pageNumber, data }) => {
    state.cardMovements = pageNumber === 1 ? data.cardMovements : state.cardMovements.concat(data.cardMovements)

    state.lastMovementInfo = {
        releaseDatePosition: data.releaseDatePosition,
        orderNumberPosition: data.orderNumberPosition
    }
    state.movementsHasMore = data.hasMore
}

/** updates card description
@payload {Object}
*/
export const UPDATE_CARD_DESCRIPTION = (state, payload) => {
    state.cardsList = state.cardsList.map(card => {
        return {
            ...card,
            friendlyName: card.id === payload.cardNumber ? payload.friendlyName : card.friendlyName
        }
    })
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
    state.cardsList = []
    state.cardMovements = []
    state.lastMovementInfo = {}
    state.movementsHasMore = false
}
